import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons/faCopy';

import { env } from '~/commons/config';
import { resolveTo } from '~/commons/helpers';
import ModalAlert from '~/commons/components/ModalAlert.jsx';
import ModalConfirm from '~/commons/components/ModalConfirm.jsx';

import ListResource from './ListResource.jsx';
import { useCompetitions } from '../../contexts/Competitions';

const ListArticles = () => {
  const isSuperAdmin = env.user.roles.includes('superAdmin');
  const { refresh } = useCompetitions();
  const history = useHistory();
  const [locked, setLocked] = useState(null);
  const [unlock, setUnlock] = useState(null);
  const [dupTargets, setDupTargets] = useState([]);
  const [listRefreshKey, setListRefreshKey] = useState(0);

  return (
    <>
      <ListResource
        key={listRefreshKey}
        searchable
        api="api/quiz/competitions"
        sort={{ createdAt: 1 }}
        onRefresh={refresh}
        cols={[
          { key: 'refCode', sortable: true },
          { key: 'title', sortable: true },
          { key: 'duration', label: 'Duration (minutes)', sortable: true },
          {
            key: 'dates',
            getter: (v) => (
              v
                ? [v[0], v.slice(-1)[0]]
                  .filter((d, i) => v.indexOf(d) === i)
                  .map((d) => moment(d).format('LL'))
                  .join(' - ')
                : ''
            ),
          },
          ...(isSuperAdmin
            ? [{
              key: 'locked',
              label: 'Locked',
              sortable: false,
              getter: (v, row) => (
                v ? (
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={(evt) => {
                      evt.stopPropagation();
                      evt.preventDefault();
                      setUnlock(row._id);
                    }}
                  >
                    Unlock
                  </button>
                ) : ''
              ),
            }]
            : []),
        ]}
        onRowClick={(row) => {
          fetch(`api/quiz/competitions/${row._id}/lock`)
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                history.push(resolveTo('', row._id));
                return;
              }
              setLocked(data.comp.locked);
            })
            .catch(() => {});
        }}
      >
        {({ selected }) => (
          selected.length > 0 && (
            <button
              type="button"
              className="btn btn-link"
              title="Duplicate selected"
              onClick={() => setDupTargets(selected)}
            >
              <FA icon={faCopy} fixedWidth />
            </button>
          )
        )}
      </ListResource>
      <ModalAlert
        show={locked != null}
        onHide={() => { setLocked(null); }}
      >
        {locked ? locked.by.name.full.en : ''} 正在使用中，請稍後再試。
      </ModalAlert>
      <ModalConfirm
        show={unlock != null}
        onReject={() => setUnlock(null)}
        onConfirm={async () => {
          fetch(`api/quiz/competitions/${unlock}/unlock`)
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                refresh();
              }
              setUnlock(null);
            })
            .catch(() => {
              setUnlock(null);
            });
        }}
      >
        Are you sure you want to unlock?
      </ModalConfirm>
      <ModalConfirm
        show={dupTargets.length > 0}
        onReject={() => setDupTargets([])}
        onConfirm={async () => {
          const targets = dupTargets.filter((row) => row?._id);

          setDupTargets([]);
          if (!targets.length) return;

          const results = await Promise.allSettled(
            targets.map((target) => (
              fetch(`api/quiz/competitions/${target._id}/duplicate`, { method: 'post' })
                .then((res) => res.json())
            )),
          );
          const hasSuccess = results.some((result) => (
            result.status === 'fulfilled' && result.value?.success
          ));

          if (hasSuccess) {
            setListRefreshKey((v) => v + 1);
            refresh();
          }
        }}
      >
        {`Duplicate ${dupTargets.length > 1 ? `${dupTargets.length} competitions` : 'this competition'}?`}
      </ModalConfirm>
    </>
  );
};

export default ListArticles;
